module.exports = __webpack_public_path__ + "components/app-store/static/s4-94d7ce5dd6bb031e3a2af8ce2cc70be3.jpg";